import Config from '@/utils/Config.js'

export function getToken() {
  return window.localStorage.getItem(Config.tokenKey) || window.localStorage.getItem('TOKEN')
}
